import React, { useEffect, useState } from "react";
import { LifeBuoy } from "lucide-react";
import api from "@/lib/api";

/**
 * Tiny "Need help?" anchor — fetches the support email from /api/config once
 * (so it can be configured by env var without rebuilding the frontend).
 */
export default function SupportLink({ className = "" }) {
  const [email, setEmail] = useState("support@pawbookhq.com");

  useEffect(() => {
    let cancelled = false;
    api.get("/config")
      .then((res) => { if (!cancelled && res.data?.supportEmail) setEmail(res.data.supportEmail); })
      .catch(() => { /* fall back to default */ });
    return () => { cancelled = true; };
  }, []);

  return (
    <a
      data-testid="support-link"
      href={`mailto:${email}?subject=Pawbook%20help%20request`}
      className={`inline-flex items-center gap-1.5 text-sm text-slate-500 hover:text-slate-800 ${className}`}
      title={`Email us at ${email}`}
    >
      <LifeBuoy size={14} />
      Need help?
    </a>
  );
}
